import { COLLECTION_EVENT_LOOKUP_ID, COLLECTION_EVENT_SEARCH_ID, newCollection } from './collectionModel'
import { EVENT_ROUTE_PREFIX } from './nativeSportsbookManifest'

// Every game a screen names directly. The preview catalog only carries the
// first inventory page, so these are fetched by id and merged in; a manual pick
// then renders the same way the app resolves it instead of falling back.
export function referencedEventIds(components) {
  const ids = new Set()
  const add = (id) => { if (typeof id === 'string' && id) ids.add(id) }
  const route = (action) => {
    const value = action?.route
    if (typeof value === 'string' && value.startsWith(EVENT_ROUTE_PREFIX)) add(value.slice(EVENT_ROUTE_PREFIX.length))
  }
  const selector = (target) => { if (target.event_selector?.mode === 'manual') add(target.event_selector.event_id) }
  for (const component of components) {
    selector(component)
    route(component.action)
    for (const id of component.event_ids || []) add(id)
    for (const id of component.collection?.pinned_event_ids || []) add(id)
    for (const id of component.collection?.excluded_event_ids || []) add(id)
    for (const card of component.cards || []) {
      selector(card)
      route(card.action)
      add(card.event_id)
      for (const leg of card.legs || []) add(leg.event_id)
    }
  }
  return [...ids].sort()
}

// One pick seeds its game under this key so it renders before the batch refetches.
export function referencedEventQueryKey(slug, source, regulation, id) {
  return ['native-event', slug, source, regulation, id]
}

export function referencedEventsQueryKey(slug, source, regulation, ids) {
  return ['native-events', slug, source, regulation, ids.join(',')]
}

// The collection contract caps event_ids and limit at 20, so a screen's
// references hydrate in at most a few requests instead of one per game.
export const EVENT_LOOKUP_BATCH = 20

export function eventLookupDefinition(ids) {
  return { ...newCollection({}, COLLECTION_EVENT_LOOKUP_ID), event_ids: ids, limit: ids.length }
}

// state narrows to what the field can use: momentum needs a live game.
export function eventSearchDefinition(query, state = 'active') {
  return { ...newCollection({}, COLLECTION_EVENT_SEARCH_ID), kind: 'search', query: query.trim(), order: 'relevance', state, limit: 20 }
}
